/* Config File for UAT environment */

import { shared_report_options } from './constants';

export const config = {
    "token_verification_endpoint": 'https://ca-verify.myresponse.me/uat-proxy.php', //needs to be replaced with the Java Backend

    "categories": [
        {
            "title" : "Volume",
            "reports": [
                {
                    "title": "Submitted Applicants by Month - Running Totals",
                    "url": "https://tableauqa.webadmit.org/views/Volume_Reports_0/SubmittedApplicantsbyMonthRunningTotals",
                    "thumbnail": "Bar.svg",
                    "options": shared_report_options
                },

                {
                    "title": "Submitted Applicants by Week - Running Totals",
                    "url": "https://tableauqa.webadmit.org/views/Volume_Reports_0/SubmittedApplicantsbyWeekRunningTotals",
                    "thumbnail": "Bar.svg",
                    "options": shared_report_options
                },

                {
                    "title": "Submitted Applicants by Month – Discrete Totals",
                    "url": "https://tableauqa.webadmit.org/views/Volume_Reports_0/SubmittedApplicantsbyMonthDiscreteTotals",
                    "thumbnail": "Line.svg",
                    "options": shared_report_options
                }
            ]
        },
        {
            "title" : "Demographic",
            "reports": [
                {
                    "title": "Applicants by Age – Count",
                    "url": "https://tableauqa.webadmit.org/views/Demographic_Reports/ApplicantsbyAgeCount",
                    "thumbnail": "Bubble.svg",
                    "options": shared_report_options
                },
                {
                    "title": "Applicants by Age – Percentage",
                    "url": "https://tableauqa.webadmit.org/views/Demographic_Reports/ApplicantsbyAgePercentage",
                    "thumbnail": "Pie.svg",
                    "options": shared_report_options
                },
                {
                    "title": "Applicants by Sex – Count",
                    "url": "https://tableauqa.webadmit.org/views/Demographic_Reports/ApplicantsbySexorGenderCount",
                    "thumbnail": "Bubble.svg",
                    "options": shared_report_options
                },
                {
                    "title": "Applicants by Sex – Percentage",
                    "url": "https://tableauqa.webadmit.org/views/Demographic_Reports/ApplicantsbySexorGenderPercentage",
                    "thumbnail": "Pie.svg",
                    "options": shared_report_options
                },
                {
                    "title": "Applicants by Ethnicity and Race – Count",
                    "url": "https://tableauqa.webadmit.org/views/Demographic_Reports/ApplicantsbyEthnicityandRaceCount",
                    "thumbnail": "HorizontalBar.svg",
                    "options": shared_report_options
                },
                {
                    "title": "Applicants by Ethnicity and Race – Percentage",
                    "url": "https://tableauqa.webadmit.org/views/Demographic_Reports/ApplicantsbyEthnicityandRacePercentage",
                    "thumbnail": "Pie.svg",
                    "options": shared_report_options
                },
                {
                    "title": "Applicant Age by Sex – Count",
                    "url": "https://tableauqa.webadmit.org/views/Demographic_Reports/ApplicantAgebySexCount",
                    "thumbnail": "HorizontalBar.svg",
                    "options": shared_report_options
                },
                {
                    "title": "Applicant Age by Sex – Percentage",
                    "url": "https://tableauqa.webadmit.org/views/Demographic_Reports/ApplicantAgebySexPercentage",
                    "thumbnail": "HorizontalBar.svg",
                    "options": shared_report_options
                },
                {
                    "title": "Applicant Ethnicity and Race by Sex – Count",
                    "url": "https://tableauqa.webadmit.org/views/Demographic_Reports/ApplicantEthnicityandRacebySexCount",
                    "thumbnail": "HorizontalBar.svg",
                    "options": shared_report_options
                },
                {
                    "title": "Applicant Ethnicity and Race by Sex – Percentage",
                    "url": "https://tableauqa.webadmit.org/views/Demographic_Reports/ApplicantEthnicityandRacebySexPercentage",
                    "thumbnail": "StackedBar.svg",
                    "options": shared_report_options
                }
            ]
        },
        {
            "title" : "Residency",
            "reports": [
                {
                    "title": "Applicants by State of Residency - Map",
                    "url": "https://tableauqa.webadmit.org/views/Residency_Reports_0/ApplicantsbyStateofResidency",
                    "thumbnail": "Map.svg",
                    "options": shared_report_options
                },
                {
                    "title": "Applicants by U.S. Citizenship Status - Count",
                    "url": "https://tableauqa.webadmit.org/views/Residency_Reports_0/ApplicantsbyU_S_CitizenshipStatusCount",
                    "thumbnail": "Bubble.svg",
                    "options": shared_report_options
                },
                {
                    "title": "Applicants by U.S. Citizenship Status - Percentage",
                    "url": "https://tableauqa.webadmit.org/views/Residency_Reports_0/ApplicantsbyU_S_CitizenshipStatusPercentage",
                    "thumbnail": "Pie.svg",
                    "options": shared_report_options
                },
                {
                    "title": "Applicants by Country of Citizenship - Count",
                    "url": "https://tableauqa.webadmit.org/views/Residency_Reports_0/ApplicantsbyCountryofCitizenshipCount",
                    "thumbnail": "HorizontalBar.svg",
                    "options": shared_report_options
                },
                {
                    "title": "Non U.S. Applicants by Country of Citizenship – Map",
                    "url": "https://tableauqa.webadmit.org/views/Residency_Reports_0/Non-U_S_ApplicantsbyCountryofCitizenshipMap",
                    "thumbnail": "Map.svg",
                    "options": shared_report_options
                }
            ]
        },
        {
            "title" : "Academic History",
            "reports": [
                {
                    "title": "Highest Degree Expected – Count",
                    "url": "https://tableauqa.webadmit.org/views/Academic_History_HighestDegreeExpected_Report_0/HighestDegreeExpected",
                    "thumbnail": "HorizontalBar.svg",
                    "options": shared_report_options
                },
                {
                    "title": "Applicants by High School Attended – Count",
                    "url": "https://tableauqa.webadmit.org/views/Academic_History_HighSchool_Reports_0/ApplicantsbyHighSchoolAttendedCount",
                    "thumbnail": "HorizontalBar.svg",
                    "options": shared_report_options
                },
                {
                    "title": "Applicants by Colleges Attended - Count (Transfer Student)",
                    "url": "https://tableauqa.webadmit.org/views/Academic_History_College_Reports_0/ApplicantsbyCollegesAttended-CountTransferStudent",
                    "thumbnail": "HorizontalBar.svg",
                    "options": shared_report_options
                },
                {
                    "title": "Self-Reported Applicant GPA by Scale - Distribution",
                    "url": "https://tableauqa.webadmit.org/views/Academic_History_GPA_Reports_0/Self-ReportedApplicantGPAbyScale-Distribution",
                    "thumbnail": "Bar.svg",
                    "options": shared_report_options
                },
                {
                    "title": "Highest Self-Reported ACT  scores by section - Distribution",
                    "url": "https://tableauqa.webadmit.org/views/Academic_History_ACT_Reports_0/HighestSelf-ReportedACTScoresbySection-Distribution",
                    "thumbnail": "Bar.svg",
                    "options": shared_report_options
                },
                {
                    "title": "Highest Self-Reported SAT Scores by Section (Before March 2016) - Distribution",
                    "url": "https://tableauqa.webadmit.org/views/Academic_History_SAT_Before2016_Reports_0/HighestSelf-ReportedSATScoresbySectionBeforeMarch2016-Distribution",
                    "thumbnail": "Bar.svg",
                    "options": shared_report_options
                },
                {
                    "title": "Highest Self-Reported SAT Scores by Section (March 2016 or After) Distribution",
                    "url": "https://tableauqa.webadmit.org/views/Academic_History_SAT_After2016_Reports_0/HighestSelf-ReportedSATScoresbySectionMarch2016orAfterDistribution",
                    "thumbnail": "Bar.svg",
                    "options": shared_report_options
                }
            ]
        },
        {
            "title" : "Parental Information",
            "reports": [
                {
                    "title": "Applicant Parental Occupation and Employment Status - Count",
                    "url": "https://tableauqa.webadmit.org/views/Parental_Reports1_1/ApplicantParentalOccupationandEmploymentStatus-Count",
                    "thumbnail": "HorizontalBar.svg",
                    "options": shared_report_options
                },
                {
                    "title": "Applicant Parental Education Level – Percentage",
                    "url": "https://tableauqa.webadmit.org/views/Parental_Reports1_1/ApplicantParentalEducationLevelPercentage",
                    "thumbnail": "HorizontalBar.svg",
                    "options": shared_report_options
                },
                {
                    "title": "Applicant Living Situation Report – Percentage",
                    "url": "https://tableauqa.webadmit.org/views/Parental_Reports2_1/ApplicantLivingSituationReportPercentage",
                    "thumbnail": "Pie.svg",
                    "options": shared_report_options
                }
            ]
        },
        {
            "title" : "Activity and Career",
            "reports": [
                {
                    "title": "Applicant Activities by Type – Count",
                    "url": "https://tableauqa.webadmit.org/views/Activity_Report_1/ApplicantActivitiesbyTypeCount",
                    "thumbnail": "HorizontalBar.svg",
                    "options": shared_report_options
                },
                {
                    "title": "Applicant Total Activities Reported — Percentage",
                    "url": "https://tableauqa.webadmit.org/views/Activity_Report2_1/ApplicantTotalActivitiesReportedPercentage",
                    "thumbnail": "Pie.svg",
                    "options": shared_report_options
                },
                {
                    "title": "Applicants by Career Interest – Count",
                    "url": "https://tableauqa.webadmit.org/views/Activity_Report2_1/ApplicantsbyCareerInterestCount",
                    "thumbnail": "HorizontalBar.svg",
                    "options": shared_report_options
                }
            ]
        }
    ]
};


// WEBPACK FOOTER //
// ./src/config/uat.js